import { create } from "zustand";

interface EventsState {
  // Available options
  topicsFilterOptions: string[];
  setTopicsFilterOptions: (newFilters: string[]) => void;

  typeFilterOptions: string[];
  setTypeFilterOptions: (newFilters: string[]) => void;

  // Active filters
  filters: {
    topic: string[];
    type: string[];
    searchQuery: string;
  };

  // Actions
  setFilter: (
    key: keyof EventsState["filters"],
    value: string[] | string,
  ) => void;
  resetFilters: () => void;
  toggleFilterItem: (
    key: keyof EventsState["filters"],
    value: string,
  ) => void;
  clearFilter: (key: keyof EventsState["filters"]) => void;
}

const useFilterStore = create<EventsState>((set) => ({
  // Available options
  topicsFilterOptions: [],
  setTopicsFilterOptions: (newFilters) =>
    set({ topicsFilterOptions: newFilters }),

  typeFilterOptions: [
    "Blogs",
    "Videos",
    "Webinars on-demand",
    "White Papers",
  ],
  setTypeFilterOptions: (newFilters) => set({ typeFilterOptions: newFilters }),

  // Active filters
  filters: {
    topic: [],
    type: [],
    searchQuery: "",
  },

  // Actions
  // Set a specific filter
  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),

  // Reset all filters
  resetFilters: () =>
    set({
      filters: { topic: [], type: [], searchQuery: "" },
    }),

  // Toggle an item in an array filter (topic or type)
  toggleFilterItem: (key: keyof EventsState["filters"], value: string) =>
    set((state) => {
      const currentValues = state.filters[key];

      // Check if the value is an array
      if (Array.isArray(currentValues)) {
        const updatedValues = currentValues.includes(value)
          ? currentValues.filter((item) => item !== value)
          : [...currentValues, value];
        return {
          filters: {
            ...state.filters,
            [key]: updatedValues,
          },
        };
      }

      return state;
    }),

  // Clear a specific filter (e.g., topic or type)
  clearFilter: (key) =>
    set((state) => ({
      filters: { ...state.filters, [key]: key === "searchQuery" ? "" : [] },
    })),
}));

export default useFilterStore;